import { graphql } from '@data-access/graphql'
import type { ResultOf } from '@graphql-typed-document-node/core'

const _WishlistFragmentDoc = graphql(`
  fragment Wishlist on WishlistObject {
    id
    name
    userFirstName
    items {
      id
      productId
      productType
      publicProductId
      productName
      locationName
      image
      available
      deleted
      stars
      duration
      reviewScore
      numberOfReviews
      price
      currency
      priceCategory
      hasMultipleDurations
      hasMultiplePrices
    }
  }
`)

export const WishlistDocument = graphql(`
  query Wishlist($wishlistId: String!, $filter: WishlistFilterInput) {
    getWishlist(wishlistId: $wishlistId, filter: $filter) {
      ...Wishlist
    }
  }
`)

export const GetWishlistsDocument = graphql(`
  query getWishlists {
    getWishlists {
      ...Wishlist
    }
  }
`)

export const IsOnWishlistDocument = graphql(`
  query isOnWishlist {
    getWishlists {
      items {
        productId
        productType
      }
    }
  }
`)

export const AddItemToWishlistDocument = graphql(`
  mutation addItemToWishlist($item: CreateWishlistItemInput!, $wishlistId: String) {
    addItemToWishlist(item: $item, wishlistId: $wishlistId) {
      id
      name
      items {
        id
        productId
      }
    }
  }
`)

export const CreateWishlistDocument = graphql(`
  mutation createWishlist($input: CreateWishlistInput!) {
    createWishlist(input: $input) {
      wishlist {
        id
        name
      }
      error
    }
  }
`)

export const DeleteWishlistDocument = graphql(`
  mutation deleteWishlist($wishlistId: String!) {
    deleteWishlist(wishlistId: $wishlistId)
  }
`)

export const RemoveItemFromWishlistDocument = graphql(`
  mutation removeItemFromWishlist($productId: String!, $productType: String!) {
    removeItemFromWishlist(productId: $productId, productType: $productType) {
      id
      name
    }
  }
`)

export const RenameWishlistDocument = graphql(`
  mutation renameWishlist($wishlistId: String!, $name: String!) {
    renameWishlist(wishlistId: $wishlistId, name: $name) {
      id
      name
    }
  }
`)

export const SwitchWishlistsDocument = graphql(`
  mutation switchWishlists($wishlistItemId: String!, $newWishlistId: String!) {
    switchWishlists(newWishlistId: $newWishlistId, wishlistItemId: $wishlistItemId) {
      id
      name
    }
  }
`)

export type GetWishlistsQuery = ResultOf<typeof GetWishlistsDocument>
export type IsOnWishlistQuery = ResultOf<typeof IsOnWishlistDocument>
